// @ts-check
import BlockCard from '../BlockCard';

const TYPES = [
  ['products', 'Products'],
  ['orders', 'Orders'],
  ['customers', 'Customers'],
  ['vendors', 'Vendors'],
  ['expenses', 'Expenses'],
];

/** Bar per record type of soft-deleted rows waiting in the recycle bin. */
export default function RecoveryBlock({ block }) {
  const byType = block.data?.by_type || {};
  const rows = TYPES.filter(([k]) => byType[k] > 0).map(([k, label]) => ({ key: k, label, count: byType[k] }));
  const max = Math.max(0, ...rows.map((r) => r.count));

  return (
    <BlockCard title="Recovery" href={block.href} headline={block.headline}>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground">Nothing in the recycle bin</p>
      ) : (
        <ul className="space-y-2">
          {rows.map((r) => (
            <li key={r.key} data-testid="recovery-type" className="text-sm">
              <div className="flex items-center justify-between">
                <span>{r.label}</span>
                <span className="font-medium">{r.count}</span>
              </div>
              <div className="mt-1 h-2 rounded bg-muted">
                <div data-testid="recovery-bar" className="h-2 rounded bg-primary" style={{ width: `${(r.count / max) * 100}%` }} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </BlockCard>
  );
}
